// BlogList.jsx
import React, { useEffect, useState } from "react";
import { db } from "./firebase";
import { collection, getDocs, orderBy, query } from "firebase/firestore";

const BlogList = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      const q = query(collection(db, "posts"), orderBy("createdAt", "desc"));
      const data = await getDocs(q);
      setPosts(data.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };

    fetchPosts();
  }, []);

  return (
    <div style={{ maxWidth: "800px", margin: "auto" }}>
      <h2>All Blog Posts</h2>
      {posts.map(post => (
        <div key={post.id} style={{ marginBottom: "30px" }}>
          <h3>{post.title}</h3>
          <p><strong>Category:</strong> {post.category}</p>
          <div dangerouslySetInnerHTML={{ __html: post.content }} />
        </div>
      ))}
    </div>
  );
};

export default BlogList;
